import { render } from "./AdvertisingMix.vue?vue&type=template&id=d05e4f02&scoped=true"
import script from "./AdvertisingMix.vue?vue&type=script&lang=js"
export * from "./AdvertisingMix.vue?vue&type=script&lang=js"

import "./AdvertisingMix.vue?vue&type=style&index=0&id=d05e4f02&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d05e4f02"]])

export default __exports__